import {StorageImageProps} from '../../types/StorageImageProps';
import {makeStorageUrl} from '../../utils/makeStorageUrl';
import {AdaptiveImage} from '../AdaptiveImage/AdaptiveImage';

export type {StorageImageProps} from '../../types/StorageImageProps';

export function StorageImage(props: StorageImageProps) {
  return <AdaptiveImage {...props} makeUrl={makeStorageUrl} />;
}
